import { useCallback } from 'react';

import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';

import ConfirmPopup from './ConfirmPopup';

export const CONFIRM_POPUP = Symbol('CONFIRM');

const DEFAULT_BUTTONS = {
  confirm: 'Confirm',
  cancel: 'Cancel',
};

export const useConfirmPopup = () => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(CONFIRM_POPUP, ConfirmPopup);
  });

  return useCallback(
    ({ classes, mode, title, content, buttons, onConfirm, onCancel, withReject }) => {
      const mergedButtons = { ...DEFAULT_BUTTONS, ...buttons };

      return new Promise((resolve, reject) => {
        popups.openPopup(CONFIRM_POPUP, {
          classes,
          mode,
          title,
          content,
          confirm: mergedButtons.confirm,
          cancel: mergedButtons.cancel,
          onConfirm: () => {
            popups.closePopup(CONFIRM_POPUP);
            resolve(true);
            if (onConfirm) {
              onConfirm();
            }
          },
          onCancel: () => {
            popups.closePopup(CONFIRM_POPUP);
            if (withReject) {
              reject();
            }
            if (onCancel) {
              onCancel();
            }
          },
        });
      });
    },
    [popups]
  );
};
